import { signal } from '@angular/core';

export interface FloatingMenuPosition {
  top: number;
  left: number;
}

export abstract class FloatingTableMenuController<T> {
  readonly openMenuId = signal<string | null>(null);
  readonly openMenuItem = signal<T | null>(null);
  readonly menuPosition = signal<FloatingMenuPosition | null>(null);

  protected toggleFloatingMenu(item: T, itemKey: string, event: MouseEvent): void {
    const trigger = event.currentTarget;

    if (!(trigger instanceof HTMLElement)) {
      return;
    }

    if (this.openMenuId() === itemKey) {
      this.closeFloatingMenu();
      return;
    }

    const rect = trigger.getBoundingClientRect();
    this.openMenuId.set(itemKey);
    this.openMenuItem.set(item);
    this.menuPosition.set({ top: rect.bottom + 6, left: rect.right });
  }

  protected closeFloatingMenu(): void {
    this.openMenuId.set(null);
    this.openMenuItem.set(null);
    this.menuPosition.set(null);
  }

  protected isFloatingMenuEventTarget(target: EventTarget | null, selectors: string[]): boolean {
    if (!(target instanceof HTMLElement)) {
      return false;
    }

    return selectors.some((selector) => target.closest(selector) !== null);
  }
}
